var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.259 16.593a8.996 8.996 0 113.148 3.148h0l-3.109.888a.751.751 0 01-.927-.927l.888-3.109h0z",
    stroke: "#232323",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.706A2.24 2.24 0 019.75 7.5h.325a.75.75 0 01.644.364l.694 1.158a.75.75 0 01.028.721l-.448.896h0a3.38 3.38 0 002.369 2.368h0l.895-.448a.75.75 0 01.721.028l1.158.694a.752.752 0 01.364.644v.325a2.24 2.24 0 01-2.206 2.25A6.75 6.75 0 017.5 9.706v0z",
    stroke: "#232323",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWhatsapp;